document.addEventListener('algolia.hooks.initialize', function () {
  if (!window.algoliaShopify || !algoliaShopify.hooks) {
    console.warn('Algolia Shopify hooks not available');
    return;
  }

  console.log('[Algolia] Custom hooks initialised');

  /* -------------------------------------------------------
   * HELPERS: SKU + STOCK (shared)
   * ----------------------------------------------------- */

  function getSkuFromItem(item) {
    return (
      item.sku ||
      item.variant_sku ||
      (Array.isArray(item.variants) &&
        item.variants[0] &&
        (item.variants[0].sku || item.variants[0].sku_code)) ||
      ''
    );
  }

  function getStockMeta(item) {
    const qty =
      typeof item.inventory_quantity === 'number'
        ? item.inventory_quantity
        : null;

    const inStock =
      item.inventory_available ||
      item.can_order ||
      (typeof item.inventory_quantity === 'number'
        ? item.inventory_quantity > 0
        : false);

    return { inStock, qty };
  }

  /* -------------------------------------------------------
   * AUTOCOMPLETE PRODUCT TEMPLATE (with SKU + stock)
   * ----------------------------------------------------- */

  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (
      _defaultTemplate,
      templateOptions,
      distinct,
      itemLink,
      trackSearchAttribution
    ) {
      const { html, item, components } = templateOptions;

      const sku = getSkuFromItem(item);
      const { inStock, qty } = getStockMeta(item);

      const stockLabel = inStock
        ? qty != null
          ? `${qty} in stock`
          : 'In stock'
        : 'Out of stock';

      const stockClass = inStock
        ? 'aa-StockBadge--in'
        : 'aa-StockBadge--out';

      // official helper for images
      const img = algoliaShopify.helpers.renderImage(item, 125);

      return html`
        <a
          class="aa-ItemLink aa-ProductItem"
          href="${itemLink}"
          ${trackSearchAttribution(html, item)}
        >
          <div class="aa-ItemContent">
            <!-- IMAGE -->
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${img.src}"
                srcset="${img.srcset}"
                sizes="${img.sizes}"
                alt="${item.title}"
              />
            </div>

            <!-- TEXT -->
            <div class="aa-ItemContentBody">
              <!-- BRAND / VENDOR -->
              <div class="aa-ItemContentBrand">
                ${
                  item.product_type &&
                  components.Highlight({ hit: item, attribute: 'product_type' })
                }
                ${
                  item.vendor &&
                  html`<span> by </span>`
                }
                ${
                  item.vendor &&
                  components.Highlight({ hit: item, attribute: 'vendor' })
                }
              </div>

              <!-- TITLE -->
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: 'title' })}
                  <span class="algolia-variant">
                    ${algoliaShopify.helpers.variantTitleAddition(
                      item,
                      distinct
                    )}
                  </span>
                </div>
              </div>

              <!-- SKU + STOCK (separate lines) -->
              ${sku
                ? html`
                    <div class="aa-SkuLine">SKU: ${sku}</div>
                  `
                : ''}
              <div class="aa-StockLine ${stockClass}">${stockLabel}</div>

              <!-- PRICE -->
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">
                  ${algoliaShopify.helpers.displayPrice(item, distinct)}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );

  /* -------------------------------------------------------
   * INSTANTSEARCH PRODUCT TEMPLATE
   *  - grid card with SKU + stock + ATC
   *  - shows variants in a <select> when available
   * ----------------------------------------------------- */

  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    function (_defaultTemplate, item, html, components) {
      const sku = getSkuFromItem(item);
      const { inStock, qty } = getStockMeta(item);

      const stockLabel = inStock
        ? qty != null
          ? `${qty} in stock`
          : 'In stock'
        : 'Out of stock';

      const stockClass = inStock
        ? 'rz-hit-stock--in'
        : 'rz-hit-stock--out';

      const productUrl = algoliaShopify.helpers.instantsearchLink(item);
      const imageUrl = algoliaShopify.helpers.mediumImage(item);
      const priceHtml = algoliaShopify.helpers.displayPrice(item);

      // VARIANTS (if provided by Algolia index)
      const variants = Array.isArray(item.variants) ? item.variants : [];
      const hasVariants = variants.length > 0;

      function getVariantId(variant) {
        return (
          variant.id ||
          variant.objectID ||
          variant.variant_id ||
          null
        );
      }

      const variantOptions = hasVariants
        ? variants
            .map(function (variant) {
              const id = getVariantId(variant);
              if (!id) return null;

              const title =
                variant.title ||
                variant.option_title ||
                'Default';

              const available =
                typeof variant.available === 'boolean'
                  ? variant.available
                  : typeof variant.inventory_quantity === 'number'
                  ? variant.inventory_quantity > 0
                  : true;

              const label = available
                ? title
                : `${title} (Sold out)`;

              return html`
                <option value="${id}" ${available ? '' : 'disabled'}>
                  ${label}
                </option>
              `;
            })
            .filter(Boolean)
        : [];

      const variantSelectBlock =
        hasVariants && variantOptions.length
          ? html`
              <label class="rz-hit-card__variant-label">
                <span class="rz-hit-card__variant-label-text">
                  Select option
                </span>
                <select
                  name="id"
                  class="rz-hit-card__variant-select"
                >
                  ${variantOptions}
                </select>
              </label>
            `
          : null;

      return html`
        <article class="rz-hit-card">

          <!-- IMAGE -->
          <a class="rz-hit-card__image-link" href="${productUrl}">
            ${imageUrl
              ? html`<img
                  class="rz-hit-card__image"
                  src="${imageUrl}"
                  alt="${item.title}"
                />`
              : ''}
          </a>

          <!-- CONTENT -->
          <div class="rz-hit-card__body">

            <!-- TITLE -->
            <h3 class="rz-hit-card__title">
              <a href="${productUrl}">
                ${components.Highlight({ attribute: 'title', hit: item })}
              </a>
            </h3>

            <!-- VENDOR -->
            ${item.vendor
              ? html`<p class="rz-hit-card__vendor">
                  ${components.Highlight({ attribute: 'vendor', hit: item })}
                </p>`
              : ''}

            <!-- SKU -->
            ${sku
              ? html`<div class="rz-hit-card__sku">SKU: ${sku}</div>`
              : ''}

            <!-- STOCK -->
            <div class="rz-hit-card__stock ${stockClass}">
              ${stockLabel}
            </div>

            <!-- PRICE -->
            <div class="rz-hit-card__price">
              ${priceHtml}
            </div>

            <!-- ADD TO CART -->
            ${item.can_order
              ? html`
                  <form
                    action="/cart/add"
                    method="post"
                    class="rz-hit-card__cart-form"
                  >
                    <!-- If we have variants in the hit, show a select.
                         Otherwise fall back to a single hidden id. -->
                    ${variantSelectBlock
                      ? variantSelectBlock
                      : html`
                          <input
                            type="hidden"
                            name="id"
                            value="${item.objectID}"
                          />
                        `}

                    <button type="submit" class="rz-hit-card__cart-btn">
                      Add to Cart
                    </button>
                  </form>
                `
              : html`
                  <button
                    class="rz-hit-card__cart-btn rz-hit-card__cart-btn--disabled"
                    disabled
                  >
                    Out of stock
                  </button>
                `}
          </div>
        </article>
      `;
    }
  );
});
